import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IConfig } from '../types/config';

export default ((state = {
  enabled: false,
  templates: '{}',
  webhook: ''
}, action: ActionObject): IConfig => {
  switch (action.type) {
    case ActionTypes.CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<IConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/reducers/config.ts